export interface AdditionalAppliancesField {
  [key: string]: string;
}

export interface AdditionalApplianceFieldItem {
  label: string;
  value: string;
}
